const EVENT_INBOX_ENDPOINTS = {
  BASE: '/event-inbox',
  BY_ID: (id: string) => `/event-inbox/${id}`,
  STATS: '/event-inbox/stats',
};

export default EVENT_INBOX_ENDPOINTS;
